import { render, staticRenderFns } from "./bounty-alipay.vue?vue&type=template&id=459ed618&scoped=true&lang=pug&"
import script from "./bounty-alipay.vue?vue&type=script&lang=js&"
export * from "./bounty-alipay.vue?vue&type=script&lang=js&"
import style0 from "./bounty-alipay.vue?vue&type=style&index=0&id=459ed618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459ed618",
  null
  
)

export default component.exports